export const typeAccount = [
  {
    label: 'Conta Corrente',
    value: 'CONTA_CORRENTE',
  },
  {
    label: 'Conta Poupança',
    value: 'CONTA_POUPANCA',
  },
  {
    label: 'Conta Fácil',
    value: 'CONTA_FACIL',
  },
  {
    label: 'Entidades Públicas',
    value: 'ENTIDADES_PUBLICAS',
  },
];

export const typePix = [
  {
    label: 'Cpf',
    value: 'CPF',
  },
  {
    label: 'Cnpj',
    value: 'CNPJ',
  },
  {
    label: 'Telefone',
    value: 'TELEFONE',
  },
  {
    label: 'E-mail',
    value: 'EMAIL',
  },
  {
    label: 'Chave aleatória',
    value: 'CHAVE_ALEATORIA',
  },
];
